/**
 * Tooth chart (owner WP2-CHART, BUILD-PLAN M06). Replaces the shell's
 * Charting placeholder (same module id and route path).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'chart',
    title: 'Tooth chart',
    version: '0.1.0',
    owner: 'WP2-CHART',
    entitlementKey: null,
    permissions: [
      'chart.view',
      'chart.edit',
      'chart.post_complete',
      'money.view',
      'settings.manage',
      'txplan.edit',
    ],
    routes: [
      {
        id: 'chart',
        path: '/charting',
        title: 'Charting',
        officeScope: 'location-or-all',
        permission: 'chart.view',
        readsPhi: true,
      },
      {
        id: 'patient-chart',
        path: '/patients/$patientId/chart',
        title: 'Tooth chart',
        officeScope: 'location-or-all',
        permission: 'chart.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Charting',
        labelKey: 'chart',
        group: 'clinical',
        routeId: 'chart',
        icon: 'smile',
        order: 10,
        permission: 'chart.view',
      },
    ],
    commands: [
      {
        id: 'chart.open',
        title: 'Go to Charting',
        keywords: ['chart', 'tooth', 'odontogram', 'restorative', 'charting'],
        routeId: 'chart',
        permission: 'chart.view',
      },
    ],
    shortcuts: [{ keys: 'g c', description: 'Go to Charting', routeId: 'chart' }],
    sseEntityKeys: ['procedure', 'tooth_state', 'clinical_note', 'chart_observation'],
    phiReadPoints: ['chart.view'],
  }),
  pages: {
    chart: () => import('./pages/ChartingPage.js'),
    'patient-chart': () => import('./pages/PatientChartPage.js'),
  },
});
